export const initialBookmark = {
  type: "section", // functional type: section, timestamp
  time: 0,
  tags: [],
  text: "",
  color: "",
  notes: "",
  duration: 0,
}
